import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  get_selectedApi2skzkr2pn0lot as get_selectedApi,
  Companion_getInstancecudcwq8yu3m7 as Companion_getInstance,
} from '../../../sdk/apiOptions.mjs';
import {
  get_session9cytjmfbg8nd as get_session,
  get_rawSession1kjo1nj4tz6n0 as get_rawSession,
} from '../../../sdk/UserSession.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../../components/nav/crowpay.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  await1kke5zj2piplv as await_0,
  awaitqeg6zusi9ora as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  listOfvhqybd2zx248 as listOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { CompletionFlowPermissionsj7m9votfuuvc as CompletionFlowPermissions } from '../../../../../../crowpay-shared/com/crowpay/completionResponse/CompletionFlowPermissions.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { IncidentFlowPermissions44pkdokiuf55 as IncidentFlowPermissions } from '../../../../../../crowpay-shared/com/crowpay/incidentResponse/IncidentFlowPermissions.mjs';
import { isPendingCompletion65tdr7y6lgp6 as isPendingCompletion } from '../../../../../../crowpay-shared/com/crowpay/statePermissions.mjs';
import {
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
  MonetaryValue__minus_impl_jw9qyp323r7b11udph7 as MonetaryValue__minus_impl_jw9qyp,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
} from '../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import {
  get_status1qu684t7g7eh as get_status,
  PayAppStatus_Pending_getInstance2ma8qo3my1dmm as PayAppStatus_Pending_getInstance,
} from '../../components/project/work/payApps/data.mjs';
import {
  ProjectView3mpzjwcpohxct as ProjectView,
  ProjectLens_Customer_getInstancedmuwwz4nvrem as ProjectLens_Customer_getInstance,
  ProjectLens_Contractor_getInstance3hm6gxlnsv3ks as ProjectLens_Contractor_getInstance,
  WorkSection_Scope_getInstance24nu4pcr0fu0d as WorkSection_Scope_getInstance,
  get_entries3gctu797fyfmn as get_entries,
} from './ProjectView.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_padded3m3frjnjujncx as get_padded,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance,
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  Frame1e7t2kcdb3wu7 as Frame,
  RowOrCol3a33s3yce2tuv as RowOrCol,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { FormModule1vzulytb0ryex as FormModule } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/kiteui/forms/FormModule.mjs';
import {
  Companion_getInstance1cdih9ztewhpv as Companion_getInstance_0,
  LineItem2rt64afaiyloc as LineItem,
  ContractorNote59o6kpmrrw5h as ContractorNote,
  ChangeRequesthd3ysa2j1i4f as ChangeRequest,
  Dispute39kejofcwuxch as Dispute,
  PunchListItem1wbu5dz9rlo4k as PunchListItem,
  ScopeView2pjeasrtqdymw as ScopeView,
  PendingItemChange1hwhwykx2kyit as PendingItemChange,
  PendingLineItem7uj25viy3ie8 as PendingLineItem,
  ItemChangee3c665suy3yz as ItemChange,
  PayApplicationmbkdcq3ut87x as PayApplication,
  PayAppItemz8p3l02jgtr9 as PayAppItem,
  LineItemCompletionMessage2zpi6q6jke1no as LineItemCompletionMessage,
  Incident3aojs8cp7629c as Incident,
  IncidentMessage1zg9aeg4hgwtu as IncidentMessage,
  ProjectMessage3vmbacgk5u7x3 as ProjectMessage,
  CompletionMessageComment2phagw82v6lch as CompletionMessageComment,
  IncidentMessageComment1adwwkgdgyo0h as IncidentMessageComment,
  ProjectTimerh0tihs6u35t6 as ProjectTimer,
  ProjectSettlementDocumentation1o22wkmr8w8uo as ProjectSettlementDocumentation,
  UnlockProjectRequestsb9zq5gbmeux as UnlockProjectRequest,
  FundsRequesthksopls9wk01 as FundsRequest,
  Projecto73xqbcrzskm as Project,
  Contractor1wog4uk4l8u77 as Contractor,
  Clientuccelyr89ch8 as Client,
} from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { form1pdmcqj387954 as form } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/kiteui/forms/FormRenderer.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { get_selectedContractor2m4vxuqdzv6k3 as get_selectedContractor } from '../../../selectedContractor.mjs';
import { toggle2o6h9frvgo8sq as toggle } from '../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  LineItemState_NotApproved_getInstance1n0ztla6z4oyz as LineItemState_NotApproved_getInstance,
  get_entries3onyqwuzh1iwq as get_entries_0,
  get_entries3ali93lr48zte as get_entries_1,
  ProjectState_Creating_getInstancegu71uom71mst as ProjectState_Creating_getInstance,
} from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { Draftj5auffrm1u2b as Draft } from '../../../../../../reactive/com/lightningkite/reactive/core/Draft.mjs';
import { MutableRememberyv35kz5kmml7 as MutableRemember } from '../../../../../../reactive/com/lightningkite/reactive/core/MutableRemember.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_project15zbqkhtwq5i6 as get_project,
  get_order2yr4ophs8mhb3 as get_order,
} from '../../../../../../crowpay-shared/com/crowpay/LineItemFields.mjs';
import {
  eq1298m2cje971u as eq,
  neqqjkp0prqcfuy as neq,
  xDataClassPathInsideSet1u5agsol0s6ul as xDataClassPathInsideSet,
} from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { SortBuilder2qc3a7b1bw9uz as SortBuilder } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/SortBuilder.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import { get_project34plxwa7097z4 as get_project_0 } from '../../../../../../crowpay-shared/com/crowpay/ContractorNoteFields.mjs';
import { get_projectgtrfvpc0zfzj as get_project_1 } from '../../../../../../crowpay-shared/com/crowpay/ChangeRequestFields.mjs';
import { get_project340dxjn5izj1d as get_project_2 } from '../../../../../../crowpay-shared/com/crowpay/DisputeFields.mjs';
import { get_project33kl9j91bsmm2 as get_project_3 } from '../../../../../../crowpay-shared/com/crowpay/PunchListItemFields.mjs';
import { get_project2bky694b9ef47 as get_project_4 } from '../../../../../../crowpay-shared/com/crowpay/ScopeViewFields.mjs';
import { get_project1h2gisnyegd0y as get_project_5 } from '../../../../../../crowpay-shared/com/crowpay/PendingItemChangeFields.mjs';
import { get_projectgc591kstp7s4 as get_project_6 } from '../../../../../../crowpay-shared/com/crowpay/PendingLineItemFields.mjs';
import { get_project1h3ocr37wkxs4 as get_project_7 } from '../../../../../../crowpay-shared/com/crowpay/ItemChangeFields.mjs';
import {
  get_project8eilj2kht5hl as get_project_8,
  get_number1dhanv5t6fc1y as get_number,
} from '../../../../../../crowpay-shared/com/crowpay/PayApplicationFields.mjs';
import {
  get_project2kz1aoxt3unwl as get_project_9,
  get_amount297a4togm1x48 as get_amount,
  get__id1xznbeynjgj8x as get__id,
} from '../../../../../../crowpay-shared/com/crowpay/PayAppItemFields.mjs';
import {
  get_project2hdo06n9xkkoa as get_project_10,
  get_created2khbw6a16fbfp as get_created,
} from '../../../../../../crowpay-shared/com/crowpay/LineItemCompletionMessageFields.mjs';
import {
  get_projectzxws9pkspb0a as get_project_11,
  get_state333q9k6vwmx2f as get_state,
} from '../../../../../../crowpay-shared/com/crowpay/IncidentFields.mjs';
import {
  get_project3c9djjff48j0d as get_project_12,
  get_createdoru21mxgd9ia as get_created_0,
} from '../../../../../../crowpay-shared/com/crowpay/IncidentMessageFields.mjs';
import {
  get_project1t10doy5antl1 as get_project_13,
  get_referencesPayApp2j107w4s6lx3b as get_referencesPayApp,
  get_referencesChangeRequest3ru7mjlfmk3mg as get_referencesChangeRequest,
  get_senderfnqbuybwjyzf as get_sender,
  get_readByax5xrch6yvl3 as get_readBy,
  get_sent1fielv150x6ow as get_sent,
} from '../../../../../../crowpay-shared/com/crowpay/ProjectMessageFields.mjs';
import { UUID21wrnrlmk5y1y as UUID } from '../../../../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import {
  SetAllElements1q4mlxrpjpkix as SetAllElements,
  And3abx79zpqd7r8 as And,
  or1ww9501dfiqpb as or,
} from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Condition.mjs';
import { get_project2fucttg0o5hjg as get_project_14 } from '../../../../../../crowpay-shared/com/crowpay/CompletionMessageCommentFields.mjs';
import { get_project1wlofjeblezw8 as get_project_15 } from '../../../../../../crowpay-shared/com/crowpay/IncidentMessageCommentFields.mjs';
import { get_projectuqhdbpbkwkr4 as get_project_16 } from '../../../../../../crowpay-shared/com/crowpay/ProjectTimerFields.mjs';
import { get_project23k9lsk7gv41f as get_project_17 } from '../../../../../../crowpay-shared/com/crowpay/ProjectSettlementDocumentationFields.mjs';
import { get_project24cljftix7ci2 as get_project_18 } from '../../../../../../crowpay-shared/com/crowpay/UnlockProjectRequestFields.mjs';
import { get_project1eezbsfxh4elg as get_project_19 } from '../../../../../../crowpay-shared/com/crowpay/FundsRequestFields.mjs';
import { AdjustedLineItemjcq04uf63gb9 as AdjustedLineItem } from '../../../utils/AdjustedLineItem.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  toMutableList20rdgwi7d3cwi as toMutableList,
  plus310ted5e4i90h as plus,
  toSet2orjxp16sotqu as toSet,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  lazygopf2ohairjp as lazy,
  shownDefaultFalse3hpz4awymyomc as shownDefaultFalse,
} from '../../../utils/utils.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../theming/separators.mjs';
import {
  get_px8ok5q0jdway2 as get_px,
  get_rem2p56fiaxda5jo as get_rem,
  get_rem14pbkv8p42gid as get_rem_0,
  get_dp28ag147e4p5cz as get_dp,
  minus1paei8txflgx9 as minus,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { expandIcon1as9er6lyg7in as expandIcon } from '../../components/expansion.mjs';
import {
  title1nssp3ryhwuqj as title,
  body3i5t0n7zprpqb as body,
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
} from '../../theming/Titles.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance_1,
  ImageRemote256pcav1ipbca as ImageRemote,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { get_edit2tiiawv2658bs as get_edit } from '../../../icons.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
} from '../../theming/buttons.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { label287uhiq3m9m4z as label2 } from '../../components/label2.mjs';
import {
  get_state23zbf4that7g as get_state_0,
  get_client1ubw0usktkrr9 as get_client,
  get_contractor2weo1umt9id6t as get_contractor,
  get_nameo9a32lyl7xbh as get_name,
} from '../../../../../../crowpay-shared/com/crowpay/ProjectFields.mjs';
import { lensPath2kkrykycsgvs9 as lensPath } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import { space2ppi73m2qk1br as space } from '../../components/space.mjs';
import { EditProject1iovryfu514gb as EditProject } from '../contractor/EditProject.mjs';
import { get_pageNavigator1inl9j7ja0vlf as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { CreateProject30799kzrue0ed as CreateProject } from '../contractor/CreateProject.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { get__id44zpbhzp4qxe as get__id_0 } from '../../../../../../crowpay-shared/com/crowpay/ContractorFields.mjs';
import { get__id2siepuxebop4k as get__id_1 } from '../../../../../../crowpay-shared/com/crowpay/ClientFields.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { Recycler21f097l2zl8cft as Recycler2 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/Recycler2.mjs';
import { get_outlinedfhcs63de0vzu as get_outlined } from '../../theming/appTheme.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { ImageViewadm9fg4ms58f as ImageView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ImageView.mjs';
import {
  ServerFile1t91jzpzoixwe as ServerFile,
  _ServerFile___get_location__impl__ddyqaq3o0wsfuapqiy2 as _ServerFile___get_location__impl__ddyqaq,
} from '../../../../../../lightning-server-shared/com/lightningkite/lightningserver/files/ServerFile.mjs';
import { contactInfo32uf9r8bl14q as contactInfo } from '../../components/contact.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_2 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { keyString2ezqnhf3jck9c as keyString } from '../../components/keyValue.mjs';
import { ProjectStateSemanticzawrm52z9108 as ProjectStateSemantic } from '../../theming/states.mjs';
import { dynamicThemexp3sdnaolntz as dynamicTheme } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { children3sl29z5no2wyp as children } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/Recycler2.ext.mjs';
import {
  get_requiredMembershipRole2ywu1e77bwer8 as get_requiredMembershipRole,
  get_awaitingApprovalMessagemcfmnhjri98l as get_awaitingApprovalMessage,
  renderFinishRegistrationbdw1wx3e9bul as renderFinishRegistration,
  renderAwaitingApprovalsh6ugtdyt2je as renderAwaitingApproval,
  render2bonfr4ls49sc as render,
  ContractorPage2yk275fy06uv3 as ContractorPage,
} from '../contractor/IsContractorScreen.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function safeSession(_this__u8e3s4) {
  if (!Companion_getInstance().efx_1.t1(_this__u8e3s4.daj(get_selectedApi())))
    throw IllegalStateException().o4('Cannot access api ' + _this__u8e3s4.gaj(get_selectedApi()).toString() + '!');
  return _this__u8e3s4.daj(get_session());
}
var DevProjectView$ProjectDevForm$render$slambdaClass;
function DevProjectView$ProjectDevForm$render$slambda() {
  if (DevProjectView$ProjectDevForm$render$slambdaClass === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    DevProjectView$ProjectDevForm$render$slambdaClass = $;
  }
  return DevProjectView$ProjectDevForm$render$slambdaClass;
}
function DevProjectView$ProjectDevForm$render$slambda_0() {
  var i = new (DevProjectView$ProjectDevForm$render$slambda())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function DevProjectView$ProjectDevForm$render$lambda(it) {
  return null;
}
function *_generator_invoke__zhh2q8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0 = session.vfw().rfg_1.zfo($this.lj4_1.hey_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.vfw().vfg_1.nfq($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.mj4_1.ley_1;
  var tmp = await_1(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_safe_receiver = tmp;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.mf9_1;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var line = tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = get_session();
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var session = tmp_1;
  var tmp_2 = session.vfw().gfg_1.ifm(line, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor($outer) {
        this.jj5_1 = $outer;
        this.nj4_1 = this.jj5_1.hey_1;
        var tmp = this;
        tmp.oj4_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj(this.jj5_1.iey_1));
        this.pj4_1 = this.jj5_1.ney_1;
        var tmp_0 = this;
        tmp_0.qj4_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj($this$remember.daj(this.jj5_1.oey_1)));
        var tmp_1 = this;
        tmp_1.rj4_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.eaj($this$remember.eaj(this.jj5_1.pey_1)));
        var tmp_2 = this;
        tmp_2.sj4_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.eaj($this$remember.daj(this.jj5_1.qey_1)));
        var tmp_3 = this;
        tmp_3.tj4_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj($this$remember.daj(this.jj5_1.tey_1)));
        var tmp_4 = this;
        tmp_4.uj4_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj($this$remember.daj(this.jj5_1.rey_1)));
        var tmp_5 = this;
        tmp_5.vj4_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj($this$remember.daj(this.jj5_1.sey_1)));
        var tmp_6 = this;
        tmp_6.wj4_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj($this$remember.daj(this.jj5_1.uey_1)));
        var tmp_7 = this;
        tmp_7.xj4_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj($this$remember.daj(this.jj5_1.vey_1)));
        var tmp_8 = this;
        tmp_8.yj4_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj($this$remember.daj(this.jj5_1.wey_1)));
        var tmp_9 = this;
        tmp_9.zj4_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj($this$remember.daj(this.jj5_1.yey_1)));
        var tmp_10 = this;
        tmp_10.aj5_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj($this$remember.daj(this.jj5_1.zey_1)));
        var tmp_11 = this;
        tmp_11.bj5_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj($this$remember.daj(this.jj5_1.aez_1)));
        var tmp_12 = this;
        tmp_12.cj5_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj($this$remember.daj(this.jj5_1.bez_1)));
        var tmp_13 = this;
        tmp_13.dj5_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj($this$remember.daj(this.jj5_1.cez_1)));
        var tmp_14 = this;
        tmp_14.ej5_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj($this$remember.daj(this.jj5_1.dez_1)));
        var tmp_15 = this;
        tmp_15.fj5_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var p = $this$remember.daj(this.oj4_1);
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = $this$remember.daj(this.lj3());
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (element.l86_1.equals(p.h7c_1)) {
              destination.v(element);
            }
          }
          var tmp$ret$3;
          $l$block_0: {
            // Inline function 'kotlin.collections.maxByOrNull' call
            var iterator = destination.m1();
            if (!iterator.n1()) {
              tmp$ret$3 = null;
              break $l$block_0;
            }
            var maxElem = iterator.o1();
            if (!iterator.n1()) {
              tmp$ret$3 = maxElem;
              break $l$block_0;
            }
            var maxValue = maxElem.m86_1.o54_1;
            do {
              var e = iterator.o1();
              var v = e.m86_1.o54_1;
              if (compareTo(maxValue, v) < 0) {
                maxElem = e;
                maxValue = v;
              }
            }
             while (iterator.n1());
            tmp$ret$3 = maxElem;
          }
          return tmp$ret$3;
        });
        var tmp_16 = this;
        tmp_16.gj5_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var p = $this$remember.daj(this.oj4_1);
          // Inline function 'kotlin.collections.groupBy' call
          var tmp0 = $this$remember.daj(this.bj5_1);
          // Inline function 'kotlin.collections.groupByTo' call
          var destination = LinkedHashMap().f6();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var key = element.y6g_1;
            // Inline function 'kotlin.collections.getOrPut' call
            var value = destination.p3(key);
            var tmp;
            if (value == null) {
              var answer = ArrayList().w();
              destination.s3(key, answer);
              tmp = answer;
            } else {
              tmp = value;
            }
            var list = tmp;
            list.v(element);
          }
          var messages = destination;
          // Inline function 'kotlin.collections.associate' call
          var this_0 = $this$remember.daj(this.pj4_1);
          var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
          // Inline function 'kotlin.collections.associateTo' call
          var destination_0 = LinkedHashMap().fc(capacity);
          var _iterator__ex2g4s_0 = this_0.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            var tmp_0 = $this$remember.daj(this.jj5_1.jey_1).zgj();
            var tmp0_safe_receiver = $this$remember.daj(get_rawSession());
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : $this$remember.daj(tmp0_safe_receiver.rfw_1);
            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.k88_1;
            var tmp_1 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.h8c_1;
            var tmp3_elvis_lhs = messages.p3(element_0.mf9_1);
            // Inline function 'kotlin.collections.plusAssign' call
            var pair = to(element_0.mf9_1, new (CompletionFlowPermissions())(element_0.jf9_1, tmp_0, tmp_1, tmp3_elvis_lhs == null ? emptyList() : tmp3_elvis_lhs, p.f7c_1));
            destination_0.s3(pair.af_1, pair.bf_1);
          }
          return destination_0;
        });
        var tmp_17 = this;
        tmp_17.hj5_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var p = $this$remember.daj(this.oj4_1);
          // Inline function 'kotlin.collections.groupBy' call
          var tmp0 = $this$remember.daj(this.dj5_1);
          // Inline function 'kotlin.collections.groupByTo' call
          var destination = LinkedHashMap().f6();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var key = element.v67_1;
            // Inline function 'kotlin.collections.getOrPut' call
            var value = destination.p3(key);
            var tmp;
            if (value == null) {
              var answer = ArrayList().w();
              destination.s3(key, answer);
              tmp = answer;
            } else {
              tmp = value;
            }
            var list = tmp;
            list.v(element);
          }
          var messages = destination;
          // Inline function 'kotlin.collections.associate' call
          var this_0 = $this$remember.daj(this.cj5_1);
          var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
          // Inline function 'kotlin.collections.associateTo' call
          var destination_0 = LinkedHashMap().fc(capacity);
          var _iterator__ex2g4s_0 = this_0.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            var tmp0_elvis_lhs = messages.p3(element_0.b63_1);
            var tmp_0 = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
            var tmp_1 = $this$remember.daj(this.jj5_1.jey_1).zgj();
            var tmp1_safe_receiver = $this$remember.daj(get_rawSession());
            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : $this$remember.daj(tmp1_safe_receiver.rfw_1);
            var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.k88_1;
            // Inline function 'kotlin.collections.plusAssign' call
            var pair = to(element_0.b63_1, new (IncidentFlowPermissions())(p, element_0, tmp_0, tmp_1, tmp3_safe_receiver == null ? null : tmp3_safe_receiver.h8c_1));
            destination_0.s3(pair.af_1, pair.bf_1);
          }
          return destination_0;
        });
        var tmp_18 = this;
        tmp_18.ij5_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var p = $this$remember.daj(this.oj4_1);
          var draws = $this$remember.daj(this.aj5_1);
          var items = $this$remember.daj(this.pj4_1);
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = items.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (isPendingCompletion(element.mfy())) {
              destination.v(element);
            }
          }
          // Inline function 'com.crowpay.extensions.sumMoney' call
          var sum = Companion_instance.r91(0n);
          var _iterator__ex2g4s_0 = destination.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            var tmp = sum;
            var tmp$ret$27 = element_0.jf9_1.q91();
            sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$27);
          }
          var workPending = sum;
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var destination_0 = ArrayList().w();
          var _iterator__ex2g4s_1 = draws.m1();
          while (_iterator__ex2g4s_1.n1()) {
            var element_1 = _iterator__ex2g4s_1.o1();
            if (get_status(element_1).equals(PayAppStatus_Pending_getInstance())) {
              destination_0.v(element_1);
            }
          }
          // Inline function 'com.crowpay.extensions.sumMoney' call
          var sum_0 = Companion_instance.r91(0n);
          var _iterator__ex2g4s_2 = destination_0.m1();
          while (_iterator__ex2g4s_2.n1()) {
            var element_2 = _iterator__ex2g4s_2.o1();
            var tmp_0 = sum_0;
            var tmp$ret$32 = element_2.r6v_1;
            sum_0 = MonetaryValue__plus_impl_c1ylt(tmp_0, tmp$ret$32);
          }
          var drawsPending = sum_0;
          return new (MonetaryValue())(MonetaryValue__minus_impl_jw9qyp(MonetaryValue__minus_impl_jw9qyp(p.u97(), workPending), drawsPending));
        });
      }
      lf8() {
        return this.nj4_1;
      }
      lfy() {
        return this.oj4_1;
      }
      vgm() {
        return this.pj4_1;
      }
      zgz() {
        return this.qj4_1;
      }
      ygk() {
        return this.rj4_1;
      }
      hgl() {
        return this.sj4_1;
      }
      wgm() {
        return this.tj4_1;
      }
      xgv() {
        return this.uj4_1;
      }
      ngy() {
        return this.wj4_1;
      }
      kgt() {
        return this.xj4_1;
      }
      lgt() {
        return this.yj4_1;
      }
      jgt() {
        return this.aj5_1;
      }
      dgt() {
        return this.bj5_1;
      }
      ggt() {
        return this.jj5_1.fez_1;
      }
      hgt() {
        return this.jj5_1.hez_1;
      }
      pgf() {
        return this.jj5_1.jez_1;
      }
      qh2() {
        return this.jj5_1.lez_1;
      }
      lj3() {
        return this.jj5_1.nez_1;
      }
      vgj() {
        return this.jj5_1.pez_1;
      }
      ogf() {
        return this.gj5_1;
      }
      uh2() {
        return this.ij5_1;
      }
    }
    initMetadataForClass($, 'Data');
    DataClass = $;
  }
  return DataClass;
}
var UnsafeProjectViewClass;
function UnsafeProjectView() {
  if (UnsafeProjectViewClass === VOID) {
    class $ extends ProjectView() {
      constructor($outer, lens, $box) {
        if ($box === VOID)
          $box = {};
        $box.bj7_1 = $outer;
        super(lens, $box);
        this.aj7_1 = this.bj7_1.qez_1;
      }
      lf8() {
        return this.aj7_1.nj4_1;
      }
      lfy() {
        return this.aj7_1.oj4_1;
      }
      vgm() {
        return this.aj7_1.pj4_1;
      }
      zgz() {
        return this.aj7_1.qj4_1;
      }
      ygk() {
        return this.aj7_1.rj4_1;
      }
      hgl() {
        return this.aj7_1.sj4_1;
      }
      wgm() {
        return this.aj7_1.tj4_1;
      }
      xgv() {
        return this.aj7_1.uj4_1;
      }
      mgz() {
        return this.aj7_1.vj4_1;
      }
      ngy() {
        return this.aj7_1.wj4_1;
      }
      kgt() {
        return this.aj7_1.xj4_1;
      }
      lgt() {
        return this.aj7_1.yj4_1;
      }
      fgt() {
        return this.aj7_1.zj4_1;
      }
      jgt() {
        return this.aj7_1.aj5_1;
      }
      dgt() {
        return this.aj7_1.bj5_1;
      }
      igt() {
        return this.aj7_1.cj5_1;
      }
      egt() {
        return this.aj7_1.dj5_1;
      }
      kj3() {
        return this.aj7_1.ej5_1;
      }
      ggt() {
        return this.aj7_1.ggt();
      }
      hgt() {
        return this.aj7_1.hgt();
      }
      pgf() {
        return this.aj7_1.pgf();
      }
      qh2() {
        return this.aj7_1.qh2();
      }
      lj3() {
        return this.aj7_1.lj3();
      }
      vgj() {
        return this.aj7_1.vgj();
      }
      ogf() {
        return this.aj7_1.gj5_1;
      }
      tgt() {
        return this.aj7_1.hj5_1;
      }
      wgj() {
        return this.aj7_1.fj5_1;
      }
      uh2() {
        return this.aj7_1.ij5_1;
      }
    }
    initMetadataForClass($, 'UnsafeProjectView', VOID, VOID, VOID, [1]);
    UnsafeProjectViewClass = $;
  }
  return UnsafeProjectViewClass;
}
var ProjectDevFormClass;
function ProjectDevForm() {
  if (ProjectDevFormClass === VOID) {
    class $ {
      constructor(project) {
        this.cj7_1 = project;
      }
      wd6(_this__u8e3s4) {
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.vbo(DevProjectView$ProjectDevForm$render$slambda_0());
        view.gba(get_AppDimensions().yg1_1);
        view.bb9(get_AppDimensions().yg1_1);
        var tmp = view.kbb(view.kbb(get_centered(view), get_scrolling(view)), view.jbb(DialogSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.gba(get_AppDimensions().yg1_1);
        view_0.bb9(get_AppDimensions().yg1_1);
        // Inline function 'kotlin.apply' call
        var this_0 = new (FormModule())();
        this_0.ndt_1.v3();
        var tmp_0 = this_0;
        tmp_0.mdt_1 = DevProjectView$ProjectDevForm$render$lambda;
        var module_0 = this_0;
        view_0.lbb(sizeConstraints(view_0, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().gg2_1), form(view_0, module_0, Companion_getInstance_0().k2a(), this.cj7_1));
        view.hbb(p_0, view_0);
        view.lbb(tmp, view_0);
        _this__u8e3s4.hbb(p, view);
        return view;
      }
    }
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'ProjectDevForm', VOID, VOID, [Page()]);
    ProjectDevFormClass = $;
  }
  return ProjectDevFormClass;
}
function DevProjectView$devLens$lambda($this$MutableRemember) {
  return !($this$MutableRemember.daj(get_selectedContractor()) == null) ? ProjectLens_Contractor_getInstance() : ProjectLens_Customer_getInstance();
}
function DevProjectView$render$lambda($this$lazy, it) {
  // Inline function 'kotlin.run' call
  it.uhf($this$lazy);
  return Unit_instance;
}
var DevProjectView$render$slambdaClass;
function DevProjectView$render$slambda() {
  if (DevProjectView$render$slambdaClass === VOID) {
    class $ {
      constructor($showProjectOptions) {
        this.dj7_1 = $showProjectOptions;
      }
      uao($completion) {
        toggle(this.dj7_1);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    DevProjectView$render$slambdaClass = $;
  }
  return DevProjectView$render$slambdaClass;
}
function DevProjectView$render$slambda_0($showProjectOptions) {
  var i = new (DevProjectView$render$slambda())($showProjectOptions);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var DevProjectView$render$slambdaClass_0;
function DevProjectView$render$slambda_1() {
  if (DevProjectView$render$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.ej7_1 = this$0;
      }
      uao($completion) {
        get_dialogStack().zgd(new (ProjectDevForm())(this.ej7_1.iey_1));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    DevProjectView$render$slambdaClass_0 = $;
  }
  return DevProjectView$render$slambdaClass_0;
}
function DevProjectView$render$slambda_2(this$0) {
  var i = new (DevProjectView$render$slambda_1())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var DevProjectView$render$slambdaClass_1;
function DevProjectView$render$slambda_3() {
  if (DevProjectView$render$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0) {
        this.lj4_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    DevProjectView$render$slambdaClass_1 = $;
  }
  return DevProjectView$render$slambdaClass_1;
}
function DevProjectView$render$slambda_4(this$0) {
  var i = new (DevProjectView$render$slambda_3())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var DevProjectView$render$slambdaClass_2;
function DevProjectView$render$slambda_5() {
  if (DevProjectView$render$slambdaClass_2 === VOID) {
    class $ {
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    DevProjectView$render$slambdaClass_2 = $;
  }
  return DevProjectView$render$slambdaClass_2;
}
function DevProjectView$render$slambda_6() {
  var i = new (DevProjectView$render$slambda_5())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function DevProjectView$render$lambda$lambda(it) {
  return it.a4_1;
}
function DevProjectView$render$lambda$lambda_0(it) {
  return it.u9b_1;
}
var DevProjectView$render$slambdaClass_3;
function DevProjectView$render$slambda_7() {
  if (DevProjectView$render$slambdaClass_3 === VOID) {
    class $ {
      constructor($showLineItemOptions) {
        this.fj7_1 = $showLineItemOptions;
      }
      uao($completion) {
        toggle(this.fj7_1);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    DevProjectView$render$slambdaClass_3 = $;
  }
  return DevProjectView$render$slambdaClass_3;
}
function DevProjectView$render$slambda_8($showLineItemOptions) {
  var i = new (DevProjectView$render$slambda_7())($showLineItemOptions);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function DevProjectView$render$lambda$lambda_1(it) {
  var tmp1_elvis_lhs = it == null ? null : it.nf9_1;
  return tmp1_elvis_lhs == null ? 'Select Line Item' : tmp1_elvis_lhs;
}
function DevProjectView$render$lambda$lambda_2(it) {
  var tmp1_elvis_lhs = it == null ? null : it.mfy();
  return tmp1_elvis_lhs == null ? LineItemState_NotApproved_getInstance() : tmp1_elvis_lhs;
}
function DevProjectView$render$lambda$lambda_3(og, it) {
  return og == null ? null : og.tfy(it);
}
function DevProjectView$render$lambda$lambda_4(it) {
  return it.l9b_1;
}
var DevProjectView$render$slambdaClass_4;
function DevProjectView$render$slambda_9() {
  if (DevProjectView$render$slambdaClass_4 === VOID) {
    class $ {
      constructor(this$0) {
        this.mj4_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    DevProjectView$render$slambdaClass_4 = $;
  }
  return DevProjectView$render$slambdaClass_4;
}
function DevProjectView$render$slambda_10(this$0) {
  var i = new (DevProjectView$render$slambda_9())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var DevProjectViewClass;
function DevProjectView() {
  if (DevProjectViewClass === VOID) {
    class $ {
      constructor(projectId) {
        this.hey_1 = projectId;
        var tmp = this;
        tmp.iey_1 = Draft(($this$Draft) => $this$Draft.eaj(safeSession($this$Draft).rfv_1.mft(this.hey_1)));
        var tmp_0 = this;
        tmp_0.jey_1 = MutableRemember().tak(VOID, VOID, VOID, VOID, DevProjectView$devLens$lambda);
        this.key_1 = Signal().hak(WorkSection_Scope_getInstance());
        this.ley_1 = Signal().hak(null);
        var tmp_1 = this;
        tmp_1.mey_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = safeSession($this$remember).ofv_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(LineItem()), arrayOf([]), false));
          var tmp$ret$0 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$0);
          var tmp_1 = eq(get_project(it), this.hey_1);
          // Inline function 'com.lightningkite.lightningdb.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_2 = serializerOrContextual(createKType(getKClass(LineItem()), arrayOf([]), false));
          var tmp$ret$5 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$5);
          this_0.k4a(get_order(it_0));
          var tmp$ret$10 = this_0.m1r();
          return tmp.heo(new (Query())(tmp_1, tmp$ret$10));
        });
        this.ney_1 = Signal().hak(emptyList());
        var tmp_2 = this;
        tmp_2.oey_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = safeSession($this$remember).bfw_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(ContractorNote()), arrayOf([]), false));
          var tmp$ret$11 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$11);
          var tmp$ret$15 = eq(get_project_0(it), this.hey_1);
          return tmp.heo(new (Query())(tmp$ret$15, VOID, VOID, 2147483647));
        });
        var tmp_3 = this;
        tmp_3.pey_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp0_safe_receiver = $this$remember.daj(this.iey_1).a7b_1;
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp = $this$remember.daj(get_session()).kfv_1.geo(tmp0_safe_receiver);
          }
          return tmp;
        });
        var tmp_4 = this;
        tmp_4.qey_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj(get_session()).lfv_1.geo($this$remember.daj(this.iey_1).x7a_1));
        var tmp_5 = this;
        tmp_5.rey_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.daj(get_session()).jfv_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(ChangeRequest()), arrayOf([]), false));
          var tmp$ret$18 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$18);
          var tmp$ret$22 = eq(get_project_1(it), this.hey_1);
          return tmp.heo(new (Query())(tmp$ret$22, VOID, VOID, 2147483647));
        });
        var tmp_6 = this;
        tmp_6.sey_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.daj(get_session()).hfw_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(Dispute()), arrayOf([]), false));
          var tmp$ret$23 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$23);
          var tmp$ret$27 = eq(get_project_2(it), this.hey_1);
          return tmp.heo(new (Query())(tmp$ret$27, VOID, VOID, 2147483647));
        });
        var tmp_7 = this;
        tmp_7.tey_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.daj(get_session()).tfv_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(PunchListItem()), arrayOf([]), false));
          var tmp$ret$28 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$28);
          var tmp$ret$32 = eq(get_project_3(it), this.hey_1);
          return tmp.heo(new (Query())(tmp$ret$32, VOID, VOID, 2147483647));
        });
        var tmp_8 = this;
        tmp_8.uey_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.daj(get_session()).wfv_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(ScopeView()), arrayOf([]), false));
          var tmp$ret$33 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$33);
          var tmp$ret$37 = eq(get_project_4(it), this.hey_1);
          return tmp.heo(new (Query())(tmp$ret$37, VOID, VOID, 2147483647));
        });
        var tmp_9 = this;
        tmp_9.vey_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.daj(get_session()).vfv_1;
          // Inline function 'com.lightningkite.lightningdb.Query' call
          var limit = 2147483647;
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(PendingItemChange()), arrayOf([]), false));
          var tmp$ret$39 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$39);
          var tmp$ret$41 = eq(get_project_5(it), this.hey_1);
          var tmp$ret$42 = new (Query())(tmp$ret$41, orderBy, 0, limit);
          return tmp.heo(tmp$ret$42);
        });
        var tmp_10 = this;
        tmp_10.wey_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.daj(get_session()).ufv_1;
          // Inline function 'com.lightningkite.lightningdb.Query' call
          var limit = 2147483647;
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(PendingLineItem()), arrayOf([]), false));
          var tmp$ret$44 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$44);
          var tmp$ret$46 = eq(get_project_6(it), this.hey_1);
          var tmp$ret$47 = new (Query())(tmp$ret$46, orderBy, 0, limit);
          return tmp.heo(tmp$ret$47);
        });
        var tmp_11 = this;
        tmp_11.xey_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.daj(get_session()).pfv_1;
          // Inline function 'com.lightningkite.lightningdb.Query' call
          var limit = 2147483647;
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(ItemChange()), arrayOf([]), false));
          var tmp$ret$49 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$49);
          var tmp$ret$51 = eq(get_project_7(it), this.hey_1);
          var tmp$ret$52 = new (Query())(tmp$ret$51, orderBy, 0, limit);
          return tmp.heo(tmp$ret$52);
        });
        var tmp_12 = this;
        tmp_12.yey_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.daj(get_session()).cfw_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(PayApplication()), arrayOf([]), false));
          var tmp$ret$53 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$53);
          var tmp_1 = eq(get_project_8(it), this.hey_1);
          // Inline function 'com.lightningkite.lightningdb.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_2 = serializerOrContextual(createKType(getKClass(PayApplication()), arrayOf([]), false));
          var tmp$ret$58 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$58);
          this_0.k4a(get_number(it_0));
          var tmp$ret$63 = this_0.m1r();
          return tmp.heo(new (Query())(tmp_1, tmp$ret$63, VOID, 2147483647));
        });
        var tmp_13 = this;
        tmp_13.zey_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.daj(get_session()).dfw_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(PayAppItem()), arrayOf([]), false));
          var tmp$ret$64 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$64);
          var tmp_1 = eq(get_project_9(it), this.hey_1);
          // Inline function 'com.lightningkite.lightningdb.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_2 = serializerOrContextual(createKType(getKClass(PayAppItem()), arrayOf([]), false));
          var tmp$ret$69 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$69);
          this_0.l4a(get_amount(it_0));
          this_0.k4a(get__id(it_0));
          var tmp$ret$74 = this_0.m1r();
          return tmp.heo(new (Query())(tmp_1, tmp$ret$74, VOID, 2147483647));
        });
        var tmp_14 = this;
        tmp_14.aez_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.daj(get_session()).efw_1;
          var tmp0_limit = 2147483647;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(LineItemCompletionMessage()), arrayOf([]), false));
          var tmp$ret$75 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$75);
          var tmp1_condition = eq(get_project_10(it), this.hey_1);
          // Inline function 'com.lightningkite.lightningdb.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(LineItemCompletionMessage()), arrayOf([]), false));
          var tmp$ret$80 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$80);
          this_0.k4a(get_created(it_0));
          var tmp2_orderBy = this_0.m1r();
          return tmp.heo(new (Query())(tmp1_condition, tmp2_orderBy, VOID, tmp0_limit));
        });
        var tmp_15 = this;
        tmp_15.bez_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.daj(get_session()).ifw_1;
          var tmp0_limit = 2147483647;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(Incident()), arrayOf([]), false));
          var tmp$ret$86 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$86);
          var tmp1_condition = eq(get_project_11(it), this.hey_1);
          // Inline function 'com.lightningkite.lightningdb.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(Incident()), arrayOf([]), false));
          var tmp$ret$91 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$91);
          this_0.m4a(get_state(it_0));
          var tmp2_orderBy = this_0.m1r();
          return tmp.heo(new (Query())(tmp1_condition, tmp2_orderBy, VOID, tmp0_limit));
        });
        var tmp_16 = this;
        tmp_16.cez_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.daj(get_session()).jfw_1;
          var tmp0_limit = 2147483647;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(IncidentMessage()), arrayOf([]), false));
          var tmp$ret$97 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$97);
          var tmp1_condition = eq(get_project_12(it), this.hey_1);
          // Inline function 'com.lightningkite.lightningdb.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(IncidentMessage()), arrayOf([]), false));
          var tmp$ret$102 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$102);
          this_0.k4a(get_created_0(it_0));
          var tmp2_orderBy = this_0.m1r();
          return tmp.heo(new (Query())(tmp1_condition, tmp2_orderBy, VOID, tmp0_limit));
        });
        var tmp_17 = this;
        tmp_17.dez_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var id = $this$remember.daj(get_session()).gfv_1;
          var tmp = $this$remember.daj(get_session()).lfw_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(ProjectMessage()), arrayOf([]), false));
          var tmp$ret$108 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$108);
          var tmp_1 = eq(get_project_13(it), this.hey_1);
          var tmp_2 = eq(get_referencesPayApp(it), null);
          var tmp_3 = eq(get_referencesChangeRequest(it), null);
          var tmp_4 = neq(get_sender(it), id);
          // Inline function 'com.lightningkite.lightningdb.all' call
          var this_0 = get_readBy(it);
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_5 = serializerOrContextual(createKType(getKClass(UUID()), arrayOf([]), false));
          var tmp$ret$110 = isInterface(tmp_5, KSerializer()) ? tmp_5 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var reader = new (DataClassPathSelf())(tmp$ret$110);
          var tmp$ret$113 = eq(reader, id);
          var tmp$ret$114 = this_0.k3t(SetAllElements().u3s(tmp$ret$113));
          var tmp_6 = And().v3q([tmp_1, tmp_2, tmp_3, tmp_4, tmp$ret$114]);
          // Inline function 'com.lightningkite.lightningdb.sort' call
          // Inline function 'kotlin.apply' call
          var this_1 = new (SortBuilder())();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_7 = serializerOrContextual(createKType(getKClass(ProjectMessage()), arrayOf([]), false));
          var tmp$ret$118 = isInterface(tmp_7, KSerializer()) ? tmp_7 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$118);
          this_1.l4a(get_sent(it_0));
          var tmp$ret$123 = this_1.m1r();
          return tmp.heo(new (Query())(tmp_6, tmp$ret$123, VOID, 1));
        });
        var tmp_18 = this;
        tmp_18.eez_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.daj(get_session()).gfw_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(CompletionMessageComment()), arrayOf([]), false));
          var tmp$ret$124 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$124);
          var tmp$ret$128 = eq(get_project_14(it), this.hey_1);
          return tmp.mdw(new (Query())(tmp$ret$128, VOID, VOID, 10000));
        });
        var tmp_19 = this;
        tmp_19.fez_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj($this$remember.daj(this.eez_1)));
        var tmp_20 = this;
        tmp_20.gez_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.daj(get_session()).kfw_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(IncidentMessageComment()), arrayOf([]), false));
          var tmp$ret$129 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$129);
          var tmp$ret$133 = eq(get_project_15(it), this.hey_1);
          return tmp.mdw(new (Query())(tmp$ret$133, VOID, VOID, 10000));
        });
        var tmp_21 = this;
        tmp_21.hez_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj($this$remember.daj(this.gez_1)));
        var tmp_22 = this;
        tmp_22.iez_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.daj(get_session()).ffw_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(ProjectTimer()), arrayOf([]), false));
          var tmp$ret$134 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$134);
          var tmp$ret$138 = eq(get_project_16(it), this.hey_1);
          return tmp.mdw(new (Query())(tmp$ret$138, VOID, VOID, 10000));
        });
        var tmp_23 = this;
        tmp_23.jez_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj($this$remember.daj(this.iez_1)));
        var tmp_24 = this;
        tmp_24.kez_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.daj(get_session()).ofw_1;
          // Inline function 'com.lightningkite.lightningdb.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(ProjectSettlementDocumentation()), arrayOf([]), false));
          var tmp$ret$140 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$140);
          var tmp$ret$142 = eq(get_project_17(it), this.hey_1);
          var tmp$ret$143 = new (Query())(tmp$ret$142, orderBy, 0, 100);
          return tmp.mdw(tmp$ret$143);
        });
        var tmp_25 = this;
        tmp_25.lez_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj($this$remember.daj(this.kez_1)));
        var tmp_26 = this;
        tmp_26.mez_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.daj(get_session()).pfw_1;
          // Inline function 'com.lightningkite.lightningdb.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(UnlockProjectRequest()), arrayOf([]), false));
          var tmp$ret$145 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$145);
          var tmp$ret$147 = eq(get_project_18(it), this.hey_1);
          var tmp$ret$148 = new (Query())(tmp$ret$147, orderBy, 0, 100);
          return tmp.mdw(tmp$ret$148);
        });
        var tmp_27 = this;
        tmp_27.nez_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj($this$remember.daj(this.mez_1)));
        var tmp_28 = this;
        tmp_28.oez_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.daj(get_session()).qfw_1;
          // Inline function 'com.lightningkite.lightningdb.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(FundsRequest()), arrayOf([]), false));
          var tmp$ret$150 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$150);
          var tmp$ret$152 = eq(get_project_19(it), this.hey_1);
          var tmp$ret$153 = new (Query())(tmp$ret$152, orderBy, 0, 100);
          return tmp.mdw(tmp$ret$153);
        });
        var tmp_29 = this;
        tmp_29.pez_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj($this$remember.daj(this.oez_1)));
        this.qez_1 = new (Data())(this);
        var tmp_30 = this;
        tmp_30.rez_1 = remember(VOID, VOID, VOID, ($this$remember) => new (UnsafeProjectView())(this, $this$remember.daj(this.jey_1)));
      }
      wd6(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(false);
        reactiveScope(view, ($this$reactiveScope) => {
          var changes = $this$reactiveScope.daj($this$reactiveScope.daj(this.xey_1));
          // Inline function 'kotlin.collections.map' call
          var this_0 = $this$reactiveScope.daj($this$reactiveScope.daj(this.mey_1));
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var item = _iterator__ex2g4s.o1();
            // Inline function 'kotlin.collections.filter' call
            // Inline function 'kotlin.collections.filterTo' call
            var destination_0 = ArrayList().w();
            var _iterator__ex2g4s_0 = changes.m1();
            while (_iterator__ex2g4s_0.n1()) {
              var element = _iterator__ex2g4s_0.o1();
              if (element.y6a_1.equals(item.e6k_1)) {
                destination_0.v(element);
              }
            }
            var tmp$ret$3 = AdjustedLineItem().jfy(item, destination_0);
            destination.v(tmp$ret$3);
          }
          this.ney_1.oam(destination);
          return Unit_instance;
        });
        reactiveScope(view, ($this$reactiveScope) => {
          var tmp0_elvis_lhs = $this$reactiveScope.daj(this.ley_1);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            return Unit_instance;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var temp = tmp;
          var lines = $this$reactiveScope.daj(this.ney_1);
          var tmp$ret$7;
          $l$block: {
            // Inline function 'kotlin.collections.indexOfFirst' call
            var index = 0;
            var _iterator__ex2g4s = lines.m1();
            while (_iterator__ex2g4s.n1()) {
              var item = _iterator__ex2g4s.o1();
              if (item.mf9_1.equals(temp.mf9_1)) {
                tmp$ret$7 = index;
                break $l$block;
              }
              index = index + 1 | 0;
            }
            tmp$ret$7 = -1;
          }
          // Inline function 'kotlin.let' call
          var index_0 = tmp$ret$7;
          var mutable = toMutableList(lines);
          mutable.z3(index_0);
          mutable.y3(index_0, temp);
          this.ney_1.oam(mutable);
          return Unit_instance;
        });
        var tmp = get_scrolling(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_1.zbm(true);
        lazy(view_1, this.rez_1, DevProjectView$render$lambda);
        view_0.hbb(p_1, view_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (Space())(view_0.pc());
        var tmp0_elvis_lhs_2 = view_0.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
        view_0.gbb(p_2, view_2);
        view_0.hbb(p_2, view_2);
        view.hbb(p_0, view_0);
        view.lbb(tmp, view_0);
        greySeparator(view);
        var tmp_0 = get_expanding(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_3 = view.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
        view.gbb(p_3, view_3);
        view_3.zbm(true);
        view_3.bb9(get_px(0));
        var showProjectOptions = Signal().hak(true);
        var showLineItemOptions = Signal().hak(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (RowOrCol())(view_3.pc());
        var tmp0_elvis_lhs_4 = view_3.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
        view_3.gbb(p_4, view_4);
        view_4.zbm(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (Button())(view_4.pc());
        var tmp0_elvis_lhs_5 = view_4.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
        view_4.gbb(p_5, view_5);
        view_5.gba(get_px(0));
        view_5.bb9(get_px(0));
        var tmp_1 = sizeConstraints(view_5, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(4));
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (RowOrCol())(view_5.pc());
        var tmp0_elvis_lhs_6 = view_5.ebb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
        view_5.gbb(p_6, view_6);
        view_6.zbm(false);
        view_6.lbb(get_centered(view_6), expandIcon(view_6, showProjectOptions));
        view_6.lbb(get_centered(view_6), title(view_6, 'Project Options'));
        view_5.hbb(p_6, view_6);
        view_5.lbb(tmp_1, view_6);
        onClick(view_5, VOID, VOID, DevProjectView$render$slambda_0(showProjectOptions));
        view_4.hbb(p_5, view_5);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (Button())(view_4.pc());
        var tmp0_elvis_lhs_7 = view_4.ebb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_4 : tmp0_elvis_lhs_7;
        view_4.gbb(p_7, view_7);
        view_7.gba(get_rem_0(0.25));
        view_7.bb9(get_rem_0(0.25));
        view_7.lbb(get_centered(view_7), icon(view_7, get_edit(Companion_getInstance_1()), 'Edit project'));
        onClick(view_7, VOID, VOID, DevProjectView$render$slambda_2(this));
        view_4.hbb(p_7, view_7);
        view_3.hbb(p_4, view_4);
        var tmp_2 = view_3.kbb(shownWhen(view_3, VOID, ($this$shownWhen) => $this$shownWhen.daj(showProjectOptions)), get_padded(view_3));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (RowOrCol())(view_3.pc());
        var tmp0_elvis_lhs_8 = view_3.ebb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view_3 : tmp0_elvis_lhs_8;
        view_3.gbb(p_8, view_8);
        view_8.zbm(true);
        var tmp_3 = get_primaryButton(view_8);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_9 = new (Button())(view_8.pc());
        var tmp0_elvis_lhs_9 = view_8.ebb_1;
        var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
        view_8.gbb(p_9, view_9);
        var tmp_4 = get_centered(view_9);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_10 = new (RowOrCol())(view_9.pc());
        var tmp0_elvis_lhs_10 = view_9.ebb_1;
        var p_10 = tmp0_elvis_lhs_10 == null ? view_9 : tmp0_elvis_lhs_10;
        view_9.gbb(p_10, view_10);
        view_10.zbm(false);
        view_10.lbb(get_centered(view_10), icon(view_10, Companion_getInstance_1().kcg_1, 'Refresh Project State'));
        view_10.lbb(get_centered(view_10), body(view_10, 'Refresh Project State'));
        view_9.hbb(p_10, view_10);
        view_9.lbb(tmp_4, view_10);
        onClick(view_9, VOID, VOID, DevProjectView$render$slambda_4(this));
        view_8.hbb(p_9, view_9);
        view_8.lbb(tmp_3, view_9);
        var tmp_5 = get_primaryButton(view_8);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_11 = new (Button())(view_8.pc());
        var tmp0_elvis_lhs_11 = view_8.ebb_1;
        var p_11 = tmp0_elvis_lhs_11 == null ? view_8 : tmp0_elvis_lhs_11;
        view_8.gbb(p_11, view_11);
        var tmp_6 = get_centered(view_11);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_12 = new (RowOrCol())(view_11.pc());
        var tmp0_elvis_lhs_12 = view_11.ebb_1;
        var p_12 = tmp0_elvis_lhs_12 == null ? view_11 : tmp0_elvis_lhs_12;
        view_11.gbb(p_12, view_12);
        view_12.zbm(false);
        view_12.lbb(get_centered(view_12), icon(view_12, Companion_getInstance_1().kcg_1, 'Refresh'));
        view_12.lbb(get_centered(view_12), body(view_12, 'Refresh Timers'));
        view_11.hbb(p_12, view_12);
        view_11.lbb(tmp_6, view_12);
        onClick(view_11, VOID, VOID, DevProjectView$render$slambda_6());
        view_8.hbb(p_11, view_11);
        view_8.lbb(tmp_5, view_11);
        label2(view_8, 'Lens', VOID, ($this$label2) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp = $this$label2.jbb(FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.select' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (Select())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.gbb(p, view);
          var tmp_0 = _Constant___init__impl__v45mub(get_entries());
          view.ocf(this.jey_1, new (Constant())(tmp_0), DevProjectView$render$lambda$lambda);
          $this$label2.hbb(p, view);
          return $this$label2.lbb(tmp, view);
        });
        label2(view_8, 'Project State', VOID, ($this$label2) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp = $this$label2.jbb(FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.select' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (Select())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.gbb(p, view);
          // Inline function 'com.lightningkite.serialization.lensPath' call
          var this_0 = this.iey_1;
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
          var tmp$ret$54 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$54);
          var tmp$ret$56 = get_state_0(it);
          var tmp_1 = lensPath(this_0, tmp$ret$56);
          var tmp_2 = _Constant___init__impl__v45mub(get_entries_0());
          view.ocf(tmp_1, new (Constant())(tmp_2), DevProjectView$render$lambda$lambda_0);
          $this$label2.hbb(p, view);
          return $this$label2.lbb(tmp, view);
        });
        view_3.hbb(p_8, view_8);
        view_3.lbb(tmp_2, view_8);
        space(view_3, get_AppDimensions().bg2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_13 = new (Button())(view_3.pc());
        var tmp0_elvis_lhs_13 = view_3.ebb_1;
        var p_13 = tmp0_elvis_lhs_13 == null ? view_3 : tmp0_elvis_lhs_13;
        view_3.gbb(p_13, view_13);
        view_13.gba(get_px(0));
        view_13.bb9(get_px(0));
        var tmp_7 = sizeConstraints(view_13, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(4));
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_14 = new (RowOrCol())(view_13.pc());
        var tmp0_elvis_lhs_14 = view_13.ebb_1;
        var p_14 = tmp0_elvis_lhs_14 == null ? view_13 : tmp0_elvis_lhs_14;
        view_13.gbb(p_14, view_14);
        view_14.zbm(false);
        view_14.lbb(get_centered(view_14), expandIcon(view_14, showLineItemOptions));
        view_14.lbb(get_centered(view_14), title(view_14, 'Work Scope Options'));
        view_14.lbb(get_centered(view_14), icon(view_14, get_edit(Companion_getInstance_1()), 'Edit Work Scope Options'));
        view_13.hbb(p_14, view_14);
        view_13.lbb(tmp_7, view_14);
        onClick(view_13, VOID, VOID, DevProjectView$render$slambda_8(showLineItemOptions));
        view_3.hbb(p_13, view_13);
        var tmp_8 = view_3.kbb(shownWhen(view_3, VOID, ($this$shownWhen) => $this$shownWhen.daj(showLineItemOptions)), get_padded(view_3));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_15 = new (RowOrCol())(view_3.pc());
        var tmp0_elvis_lhs_15 = view_3.ebb_1;
        var p_15 = tmp0_elvis_lhs_15 == null ? view_3 : tmp0_elvis_lhs_15;
        view_3.gbb(p_15, view_15);
        view_15.zbm(true);
        label2(view_15, 'Work Scope', VOID, ($this$label2) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp = $this$label2.jbb(FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.select' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (Select())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.gbb(p, view);
          var tmp_0 = remember(VOID, VOID, VOID, ($this$remember) => plus(listOf(null), $this$remember.daj(this.ney_1)));
          view.ocf(this.ley_1, tmp_0, DevProjectView$render$lambda$lambda_1);
          $this$label2.hbb(p, view);
          return $this$label2.lbb(tmp, view);
        });
        label2(view_15, 'Work Scope State', VOID, ($this$label2) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp = $this$label2.jbb(FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.select' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (Select())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.gbb(p, view);
          var tmp_0 = DevProjectView$render$lambda$lambda_2;
          var tmp_1 = this.ley_1.dak(tmp_0, DevProjectView$render$lambda$lambda_3);
          var tmp_2 = _Constant___init__impl__v45mub(get_entries_1());
          view.ocf(tmp_1, new (Constant())(tmp_2), DevProjectView$render$lambda$lambda_4);
          $this$label2.hbb(p, view);
          return $this$label2.lbb(tmp, view);
        });
        var tmp_9 = get_primaryButton(view_15);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_16 = new (Button())(view_15.pc());
        var tmp0_elvis_lhs_16 = view_15.ebb_1;
        var p_16 = tmp0_elvis_lhs_16 == null ? view_15 : tmp0_elvis_lhs_16;
        view_15.gbb(p_16, view_16);
        specCenteredText(view_16, 'Refresh State');
        onClick(view_16, VOID, VOID, DevProjectView$render$slambda_10(this));
        view_15.hbb(p_16, view_16);
        view_15.lbb(tmp_9, view_16);
        view_3.hbb(p_15, view_15);
        view_3.lbb(tmp_8, view_15);
        view.hbb(p_3, view_3);
        view.lbb(tmp_0, view_3);
        _this__u8e3s4.hbb(p, view);
        return view;
      }
    }
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'DevProjectView', VOID, VOID, [Page()]);
    DevProjectViewClass = $;
  }
  return DevProjectViewClass;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.gj7_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var p = tmp;
  var to = p.u7b_1.equals(ProjectState_Creating_getInstance()) ? new (EditProject())(p.v7a_1) : new (DevProjectView())(p.v7a_1);
  get_pageNavigator($this.hj7_1).fbw(to);
  return Unit_instance;
}
function SelectDevProjectScreen$_projects$lambda($this$remember) {
  var session = safeSession($this$remember);
  var self_0 = $this$remember.daj(session.rfw_1);
  var membership = self_0.k88_1;
  var tmp;
  if (membership == null) {
    tmp = new (Constant())(_Constant___init__impl__v45mub(emptyList()));
  } else {
    // Inline function 'com.lightningkite.lightningdb.condition' call
    // Inline function 'com.lightningkite.lightningdb.path' call
    // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
    var tmp$ret$0 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    // Inline function 'kotlin.let' call
    var it = new (DataClassPathSelf())(tmp$ret$0);
    var tmp_1 = or(eq(get_client(it), self_0.d88_1), eq(get_contractor(it), membership.g8c_1));
    // Inline function 'com.lightningkite.lightningdb.sort' call
    // Inline function 'kotlin.apply' call
    var this_0 = new (SortBuilder())();
    // Inline function 'com.lightningkite.lightningdb.path' call
    // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
    var tmp_2 = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
    var tmp$ret$5 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
    var it_0 = new (DataClassPathSelf())(tmp$ret$5);
    this_0.k4a(get_name(it_0));
    var tmp$ret$10 = this_0.m1r();
    tmp = session.rfv_1.heo(new (Query())(tmp_1, tmp$ret$10));
  }
  return tmp;
}
function SelectDevProjectScreen$renderMainContent$lambda($this$shownDefaultFalse) {
  return !($this$shownDefaultFalse.daj(get_selectedContractor()) == null);
}
var SelectDevProjectScreen$renderMainContent$slambdaClass;
function SelectDevProjectScreen$renderMainContent$slambda() {
  if (SelectDevProjectScreen$renderMainContent$slambdaClass === VOID) {
    class $ {
      constructor($$this$button) {
        this.ij7_1 = $$this$button;
      }
      uao($completion) {
        get_pageNavigator(this.ij7_1).fbw(new (CreateProject())());
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    SelectDevProjectScreen$renderMainContent$slambdaClass = $;
  }
  return SelectDevProjectScreen$renderMainContent$slambdaClass;
}
function SelectDevProjectScreen$renderMainContent$slambda_0($$this$button) {
  var i = new (SelectDevProjectScreen$renderMainContent$slambda())($$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function SelectDevProjectScreen$renderMainContent$lambda_0(it) {
  return it.v7a_1;
}
var SelectDevProjectScreen$renderMainContent$lambda$slambdaClass;
function SelectDevProjectScreen$renderMainContent$lambda$slambda() {
  if (SelectDevProjectScreen$renderMainContent$lambda$slambdaClass === VOID) {
    class $ {
      constructor($project, $$this$button) {
        this.gj7_1 = $project;
        this.hj7_1 = $$this$button;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    SelectDevProjectScreen$renderMainContent$lambda$slambdaClass = $;
  }
  return SelectDevProjectScreen$renderMainContent$lambda$slambdaClass;
}
function SelectDevProjectScreen$renderMainContent$lambda$slambda_0($project, $$this$button) {
  var i = new (SelectDevProjectScreen$renderMainContent$lambda$slambda())($project, $$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function RowOrCol$_get_visible_$ref_m9hbzh(p0) {
  return () => p0.ab9();
}
function RowOrCol$_set_visible_$ref_80wucf(p0) {
  return (_this__u8e3s4) => {
    p0.zb8(_this__u8e3s4);
    return Unit_instance;
  };
}
function Frame$_get_shown_$ref_dnks5k(p0) {
  return () => p0.yb8();
}
function Frame$_set_shown_$ref_s2otf0(p0) {
  return (_this__u8e3s4) => {
    p0.jb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function ImageView$_get_source_$ref_ain7z1(p0) {
  return () => p0.g2i();
}
function ImageView$_set_source_$ref_4jld67(p0) {
  return (_this__u8e3s4) => {
    p0.qda(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
var SelectDevProjectScreenClass;
function SelectDevProjectScreen() {
  if (SelectDevProjectScreenClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        tmp.jj7_1 = remember(VOID, VOID, VOID, SelectDevProjectScreen$_projects$lambda);
        var tmp_0 = this;
        tmp_0.kj7_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj($this$remember.daj(this.jj7_1)));
        var tmp_1 = this;
        tmp_1.lj7_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var session = safeSession($this$remember);
          var ps = $this$remember.daj(this.kj7_1);
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
          var tmp$ret$0 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$0);
          var tmp_0 = get__id_0(it);
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().u(collectionSizeOrDefault(ps, 10));
          var _iterator__ex2g4s = ps.m1();
          while (_iterator__ex2g4s.n1()) {
            var item = _iterator__ex2g4s.o1();
            var tmp$ret$2 = item.x7a_1;
            destination.v(tmp$ret$2);
          }
          var tmp$ret$7 = xDataClassPathInsideSet(tmp_0, toSet(destination));
          return session.lfv_1.heo(new (Query())(tmp$ret$7));
        });
        var tmp_2 = this;
        tmp_2.mj7_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var session = safeSession($this$remember);
          var ps = $this$remember.daj(this.kj7_1);
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp = serializerOrContextual(createKType(getKClass(Client()), arrayOf([]), false));
          var tmp$ret$8 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$8);
          var tmp_0 = get__id_1(it);
          // Inline function 'kotlin.collections.mapNotNull' call
          // Inline function 'kotlin.collections.mapNotNullTo' call
          var destination = ArrayList().w();
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = ps.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp0_safe_receiver = element.a7b_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              destination.v(tmp0_safe_receiver);
            }
          }
          var tmp$ret$19 = xDataClassPathInsideSet(tmp_0, toSet(destination));
          return session.kfv_1.heo(new (Query())(tmp$ret$19));
        });
        var tmp_3 = this;
        tmp_3.nj7_1 = remember(VOID, VOID, VOID, ($this$remember) => plus($this$remember.daj($this$remember.daj(this.lj7_1)), $this$remember.daj($this$remember.daj(this.mj7_1))));
      }
      thi(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        view.bb9(get_dp(0));
        title(view, 'Dev Projects');
        space(view, get_AppDimensions().bg2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(false);
        view_0.bb9(get_dp(0));
        space(view_0, minus(get_AppDimensions().yg1_1, get_AppDimensions().lg2_1));
        var tmp = get_primaryButton(view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (Button())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        shownDefaultFalse(view_1, SelectDevProjectScreen$renderMainContent$lambda);
        specCenteredText(view_1, '+ Project to current contractor');
        onClick(view_1, VOID, VOID, SelectDevProjectScreen$renderMainContent$slambda_0(view_1));
        view_0.hbb(p_1, view_1);
        view_0.lbb(tmp, view_1);
        view.hbb(p_0, view_0);
        space(view, get_AppDimensions().bg2_1);
        var tmp_0 = get_centered(view);
        // Inline function 'com.crowpay.views.theming.subTitle' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (TextView())(view.pc());
        var tmp0_elvis_lhs_2 = view.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
        view.gbb(p_2, view_2);
        view_2.lba(view_2.qb6_1.abf(SubtitleSemantic_getInstance()));
        shownDefaultFalse(view_2, ($this$shownDefaultFalse) => $this$shownDefaultFalse.daj(this.kj7_1).i1());
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var value = 'You have no projects';
        var tmp_1 = view_2.vb5_1;
        var tmp_2;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(value) === 0) {
          tmp_2 = '\xA0';
        } else {
          tmp_2 = value;
        }
        tmp_1.hbu(tmp_2);
        view.hbb(p_2, view_2);
        view.lbb(tmp_0, view_2);
        var tmp_3 = get_expanding(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.recyclerView' call
        // Inline function 'kotlin.apply' call
        var this_0 = new (Recycler2())(view, true);
        var tmp_4 = SelectDevProjectScreen$renderMainContent$lambda_0;
        children(this_0, this.kj7_1, tmp_4, ($this$children, project) => {
          var contact = remember(VOID, VOID, VOID, ($this$remember) => {
            var p = $this$remember.daj(project);
            // Inline function 'kotlin.collections.find' call
            var tmp0 = $this$remember.daj(this.nj7_1);
            var tmp$ret$15;
            $l$block: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var _iterator__ex2g4s = tmp0.m1();
              while (_iterator__ex2g4s.n1()) {
                var element = _iterator__ex2g4s.o1();
                var tmp;
                if (element instanceof Client()) {
                  tmp = element.b5c_1.equals(p.a7b_1);
                } else {
                  if (element instanceof Contractor()) {
                    tmp = element.t5i_1.equals(p.x7a_1);
                  } else {
                    tmp = false;
                  }
                }
                if (tmp) {
                  tmp$ret$15 = element;
                  break $l$block;
                }
              }
              tmp$ret$15 = null;
            }
            return tmp$ret$15;
          });
          var tmp = sizeConstraints($this$children, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().gg2_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$children.pc());
          var tmp0_elvis_lhs = $this$children.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$children : tmp0_elvis_lhs;
          $this$children.gbb(p, view);
          view.zbm(false);
          view.bb9(get_dp(0));
          space(view, get_AppDimensions().ag2_1);
          var tmp_0 = view.kbb(get_outlined(view), get_expanding(view));
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (Button())(view.pc());
          var tmp0_elvis_lhs_0 = view.ebb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.gbb(p_0, view_0);
          view_0.gba(get_AppDimensions().zg1_1);
          view_0.bb9(get_AppDimensions().zg1_1);
          onClick(view_0, VOID, VOID, SelectDevProjectScreen$renderMainContent$lambda$slambda_0(project, view_0));
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (RowOrCol())(view_0.pc());
          var tmp0_elvis_lhs_1 = view_0.ebb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
          view_0.gbb(p_1, view_1);
          view_1.zbm(true);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (RowOrCol())(view_1.pc());
          var tmp0_elvis_lhs_2 = view_1.ebb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
          view_1.gbb(p_2, view_2);
          view_2.zbm(false);
          var tmp_1 = get_centered(view_2);
          // Inline function 'com.crowpay.views.theming.subTitle' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_3 = new (TextView())(view_2.pc());
          var tmp0_elvis_lhs_3 = view_2.ebb_1;
          var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
          view_2.gbb(p_3, view_3);
          view_3.lba(view_3.qb6_1.abf(SubtitleSemantic_getInstance()));
          var tmp_2 = KMutableProperty0();
          var tmp_3 = TextView$_get_content_$ref_4pzcwl(view_3);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(view_3));
          reactiveScope(view_3, ($this$reactiveScope) => {
            var tmp$ret$17 = $this$reactiveScope.daj(project).b7b_1;
            this_0.set(tmp$ret$17);
            return Unit_instance;
          });
          view_2.hbb(p_3, view_3);
          view_2.lbb(tmp_1, view_3);
          greySeparator(view_2);
          var tmp_4 = get_expanding(view_2);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_4 = new (RowOrCol())(view_2.pc());
          var tmp0_elvis_lhs_4 = view_2.ebb_1;
          var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
          view_2.gbb(p_4, view_4);
          view_4.zbm(false);
          var tmp_5 = KMutableProperty0();
          var tmp_6 = RowOrCol$_get_visible_$ref_m9hbzh(view_4);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_1 = getPropertyCallableRef('visible', 0, tmp_5, tmp_6, RowOrCol$_set_visible_$ref_80wucf(view_4));
          reactiveScope(view_4, ($this$reactiveScope) => {
            var tmp$ret$24 = !($this$reactiveScope.daj(contact) == null);
            this_1.set(tmp$ret$24);
            return Unit_instance;
          });
          var tmp_7 = view_4.kbb(sizeConstraints(view_4, VOID, VOID, VOID, VOID, VOID, get_rem(3), get_rem(3)), get_centered(view_4));
          // Inline function 'com.lightningkite.kiteui.views.direct.image' call
          // Inline function 'kotlin.apply' call
          var this_2 = new (ImageView())(view_4);
          var tmp0 = this_2.cda_1;
          var tmp_8 = KMutableProperty0();
          var tmp_9 = Frame$_get_shown_$ref_dnks5k(tmp0);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_3 = getPropertyCallableRef('shown', 0, tmp_8, tmp_9, Frame$_set_shown_$ref_s2otf0(tmp0));
          reactiveScope(view_4, ($this$reactiveScope) => {
            var tmp0_safe_receiver = $this$reactiveScope.daj(contact);
            var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q92();
            var tmp$ret$26 = !((tmp == null ? null : new (ServerFile())(tmp)) == null);
            this_3.set(tmp$ret$26);
            return Unit_instance;
          });
          var tmp_10 = KMutableProperty0();
          var tmp_11 = ImageView$_get_source_$ref_ain7z1(this_2);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_4 = getPropertyCallableRef('source', 0, tmp_10, tmp_11, ImageView$_set_source_$ref_4jld67(this_2));
          reactiveScope(view_4, ($this$reactiveScope) => {
            var tmp0_safe_receiver = $this$reactiveScope.daj(contact);
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q92();
            var tmp;
            var tmp_0 = tmp1_safe_receiver;
            if ((tmp_0 == null ? null : new (ServerFile())(tmp_0)) == null) {
              tmp = null;
            } else {
              tmp = _ServerFile___get_location__impl__ddyqaq(tmp1_safe_receiver);
            }
            var tmp2_elvis_lhs = tmp;
            var tmp$ret$28 = new (ImageRemote())(tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs);
            this_4.set(tmp$ret$28);
            return Unit_instance;
          });
          this_2.bbb();
          view_4.lbb(tmp_7, this_2);
          get_centered(view_4);
          contactInfo(view_4, contact);
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
          Companion_getInstance_2();
          view_2.hbb(p_4, view_4);
          view_2.lbb(tmp_4, view_4);
          view_2.lbb(get_centered(view_2), icon(view_2, Companion_getInstance_1().bcg_1, 'Open'));
          view_1.hbb(p_2, view_2);
          greySeparator(view_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_5 = new (RowOrCol())(view_1.pc());
          var tmp0_elvis_lhs_5 = view_1.ebb_1;
          var p_5 = tmp0_elvis_lhs_5 == null ? view_1 : tmp0_elvis_lhs_5;
          view_1.gbb(p_5, view_5);
          view_5.zbm(false);
          var tmp_12 = get_expanding(view_5);
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_6 = new (RowOrCol())(view_5.pc());
          var tmp0_elvis_lhs_6 = view_5.ebb_1;
          var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
          view_5.gbb(p_6, view_6);
          view_6.zbm(true);
          keyString(view_6, 'Total Price', ($this$keyString) => MonetaryValue__toString_impl_xslc77($this$keyString.daj(project).w7b_1));
          keyString(view_6, 'Contractor Payments', ($this$keyString) => MonetaryValue__toString_impl_xslc77($this$keyString.daj(project).c7c_1));
          keyString(view_6, 'Escrow Balance', ($this$keyString) => MonetaryValue__toString_impl_xslc77($this$keyString.daj(project).u97()));
          view_5.hbb(p_6, view_6);
          view_5.lbb(tmp_12, view_6);
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_7 = new (TextView())(view_5.pc());
          var tmp0_elvis_lhs_7 = view_5.ebb_1;
          var p_7 = tmp0_elvis_lhs_7 == null ? view_5 : tmp0_elvis_lhs_7;
          view_5.gbb(p_7, view_7);
          view_7.lba(view_7.qb6_1.abf(BodySemantic_getInstance()));
          var tmp_13 = KMutableProperty0();
          var tmp_14 = TextView$_get_content_$ref_4pzcwl_0(view_7);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_5 = getPropertyCallableRef('content', 0, tmp_13, tmp_14, TextView$_set_content_$ref_pketfb_0(view_7));
          reactiveScope(view_7, ($this$reactiveScope) => {
            var tmp$ret$47 = $this$reactiveScope.daj(project).u7b_1.u9b_1;
            this_5.set(tmp$ret$47);
            return Unit_instance;
          });
          dynamicTheme(view_7, ($this$dynamicTheme) => ProjectStateSemantic().eh1($this$dynamicTheme.daj(project).u7b_1));
          view_5.hbb(p_7, view_7);
          view_1.hbb(p_5, view_5);
          view_0.hbb(p_1, view_1);
          view.hbb(p_0, view_0);
          view.lbb(tmp_0, view_0);
          space(view, get_AppDimensions().ag2_1);
          $this$children.hbb(p, view);
          return $this$children.lbb(tmp, view);
        });
        view.lbb(tmp_3, this_0);
        _this__u8e3s4.hbb(p, view);
      }
    }
    protoOf($).dhg = get_requiredMembershipRole;
    protoOf($).fhg = get_awaitingApprovalMessage;
    protoOf($).ghg = renderFinishRegistration;
    protoOf($).hhg = renderAwaitingApproval;
    protoOf($).wd6 = render;
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'SelectDevProjectScreen', SelectDevProjectScreen, VOID, [ContractorPage()]);
    SelectDevProjectScreenClass = $;
  }
  return SelectDevProjectScreenClass;
}
//region block: exports
export {
  UnsafeProjectView as UnsafeProjectView23b4rskm6lqhw,
  DevProjectView as DevProjectViewbz7mvcn13n05,
  SelectDevProjectScreen as SelectDevProjectScreenktpl27uiowry,
};
//endregion

//# sourceMappingURL=DevProjectView.mjs.map
